const defaultFilters = {
  categoryIdSelected: undefined,
  searchText: undefined,
  price: undefined,
  time: undefined,
  color: undefined,
  materials: [],
  productTypes: [],
  productVersions: [],
  categories: [],
  orderBy: undefined
}

const defaultPaginate = {
  current_page: 1,
  last_page: 1,
  from: 1,
  to: 1,
  total: 1,
  per_page: 24
}

const defaultState = {
  filters: localStorage.getItem('catalogueFilters') ? JSON.parse(localStorage.getItem('catalogueFilters')) : defaultFilters,
  paginate: localStorage.getItem('cataloguePaginate') ? JSON.parse(localStorage.getItem('cataloguePaginate')) : defaultPaginate
}

export const state = () => ({
  ...defaultState
})

// getters
const getters = {
  getFilters: (actualState) => actualState.filters
}

// mutations
const mutations = {
    setFilters(state, filters) {
        state.filters = filters
        localStorage.setItem('catalogueFilters', JSON.stringify(filters))
    },
    resetFilters(state) {
        state.filters = defaultFilters
        localStorage.setItem('catalogueFilters', JSON.stringify(defaultFilters))
    },
    setPaginate(state, paginate) {
        state.paginate = paginate
        localStorage.setItem('cataloguePaginate', JSON.stringify(paginate))
    },
    resetPaginate(state) {
        state.paginate = defaultPaginate
        localStorage.setItem('cataloguePaginate', JSON.stringify(defaultPaginate))
    }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
